import { render, staticRenderFns } from "./houseList.vue?vue&type=template&id=a5d42692&scoped=true"
import script from "./houseList.vue?vue&type=script&lang=js"
export * from "./houseList.vue?vue&type=script&lang=js"
import style0 from "./houseList.vue?vue&type=style&index=0&id=a5d42692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d42692",
  null
  
)

export default component.exports